import * as React from 'react';
import * as TinyMCE from 'tinymce';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/code';
// import 'jquery';
// import 'jquery-ui';
// import 'jquery-ui/ui/widgets/sortable';
// import '../../libs/contentbuilder/contentbuilder-src.js';
// import '../../libs/contentbuilder/contentbuilder.css';
// import '../../libs/contentbuilder/jquery-1.11.1.min.js';
// import '../../libs/contentbuilder/jquery-ui.min.js';
import { Field } from '../libs/form.lib';
import { ValidatorComponent } from '../libs/validator.component';
import { Validator } from '../libs/Validators';
import { ResourceModal } from '../structurals/resource-modal';
import { get, map } from 'lodash';

// declare const $: any;
// tslint:disable

export interface WysiwygFieldPropInterface {
    className?: string;
    title?: string;
    placeholder?: string;
    property?: string;
    validators?: Validator[];
    field: Field;
    onChange?: (value: any) => void;
    customMenu?: any,
    height?: number
}

export class WysiwygField extends React.Component<WysiwygFieldPropInterface> {
    public field: Field = this.props.field;
    public height: any = this.props.height;
    public uid: string = 'wwf' + Math.floor(Math.random() * 10000000);
    public config: any = {
        selector: '#' + this.uid,
        width: '100%',
        height: this.height ? this.height : 300,
        inline: false,
        statusbar: false,
        relative_urls: false,
        remove_script_host: false,
        force_br_newlines : false,
        force_p_newlines : false,
        forced_root_block : '',
        menu: {},
        plugins: [
            'advlist image lists charmap hr link code',
            'media nonbreaking',
            'table contextmenu directionality template paste textcolor'
        ],
        toolbar: 'insertfile undo redo | styleselect | bold italic | blockquote | alignleft aligncenter alignright alignjustify | bullist numlist | forecolor backcolor | link custom-media-item-select | charmap removeformat | code mailTemplateVariables ',
        init_instance_callback: (editor: any) => {
            this.afterTinyMCEInit(editor);
        },
        content_css: [
            '/atas_site.css'
        ],
        setup: (editor: any) => {
            editor.addButton('custom-media-item-select', {
                icon: 'image',
                tooltip: 'Insert image',
                onclick: () => this.handleCreateMediaModal(editor)
            });

            if (this.props.customMenu) {
                this.customFields(editor);
            }

        }
    };
    public state: any = {
        error: null,
        mediaModalPlacement: null,
        customMenu: null
    };

    private customFields(editor: any) {
        const buttons = new Array();

        map(this.props.customMenu,(entity: any, index: any) => {
            const menu: any = {
                text: index,
                menu: []
            }
            const menuButtons = new Array()
            map(entity, (m: any) => {
                const subMenu = {
                    text: m.name,
                    onclick: function() {
                        editor.insertContent(m.variable);
                    }
                }
                menuButtons.push(subMenu)
            })
            menu.menu = menuButtons;
            buttons.push(menu);
        })

        editor.addButton('mailTemplateVariables', {
            type: 'menubutton',
            text: 'Mail template variables',
            icon: false,
            menu: buttons
        });

    }

    handleCreateMediaModal(editor: any) {
        const element = React.createElement(ResourceModal, {
            entity: 'file-manager',
            config: {
                multi: false,
                defaultOpen: true,
                onSelectSuccessful: (mediaItem: any) => {
                    editor.insertContent(`<img width="100%" src="${get(mediaItem, 'images.original')}" alt="${get(mediaItem, 'description')}"/>`);
                    this.setState({mediaModalPlacement: null});
                },
            },
        });
        this.setState({mediaModalPlacement: element});

        // todo -> Destroy previous modal if closed or selected
    }

    componentDidMount() {
        this.field.registerField();
        TinyMCE.init(this.config);


        if (this.props.customMenu) {
            this.setState({customMenu: this.props.customMenu})
        }
        if (this.props.validators) {
            this.props.validators.forEach((v: Validator) => this.field.addValidator(v));
        }

        this.field.onValueChanges$.subscribe((value: any) => {
            if (this.props.onChange) {
                this.props.onChange(value);
            }
            this.field.onValidate$.next();
        });

        if (this.field.value && this.field.registered) {
            this.setViewValue(this.field.value);
        }
    }

    public afterTinyMCEInit(editor: any) {
        editor.on('change', () => {
            const content = TinyMCE.activeEditor.getContent();
            this.field.setValue(content, false, true);
        });
        this.setViewValue(this.field.value);
    }

    public setViewValue(value: any) {
        TinyMCE.activeEditor.setContent(value || '');
    }

    render() {
        return (
            <div className='w-100 relative form-group'>

                <label>{this.props.title || this.field.title || ''}</label>
                <div id={this.uid} className="container"/>

                <ValidatorComponent field={this.field}/>

                {this.state.mediaModalPlacement}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/fields/wysiwyg.field.tsx